import React from 'react'
import TradingPane from '../containers/TradingPane'
import { PositionsInputs, AppMode } from '../types'
import {
  PricesExtended,
  TradeObject,
  TradeType,
  ModifyTrade,
  TradeCommandType,
} from '@bdswiss/mt4-connector'
import PositionEdit from './PositionEdit'
// import {PricesExtended, TradeObject} from '@bdswiss/mt4-connector';

export interface Props {
  locale: string
  accountLoaded: boolean
  assetsOpened: boolean
  positionsOpened: boolean
  tradingPaneOpened: boolean
  editPaneOpened: boolean
  sidebarOpened: boolean
  assets: PricesExtended
  positions: Map<number, TradeObject>
  pendingOrders: Map<number, TradeObject>
  positionsInputs: PositionsInputs
  currency: string
  tradeOperationEnabled: boolean
  favourites: string[]
  appMode: AppMode
  selectedPosition?: number
  positionExpanded?: boolean
  selectedOrder?: number
  orderExpanded?: boolean
  onModifyTrade: (trade: ModifyTrade, tradeType: TradeType) => void
  onCloseTrade: (order: number, uuid?: string) => void
  onCancelPendingOrder: (order: number, uuid?: string) => void
  onInputStopLoss: (order: number, value: number) => void
  onInputTakeProfit: (order: number, value: number) => void
  onInputPrice: (order: number, value: number) => void
  onToggleFavourite: (favourites: string[]) => void
  onShowChart: (symbol: string, tradeType: TradeCommandType) => void
  onSelectPosition: (order: number, expanded?: boolean) => void
}

export const Sidebar = (props: Props) => {
  const {
    positions,
    pendingOrders,
    tradingPaneOpened,
    assets,
    currency,
    locale,
    positionsInputs,
    selectedPosition,
    positionExpanded,
    selectedOrder,
    orderExpanded,
    tradeOperationEnabled,
    accountLoaded,
    onModifyTrade,
    onCloseTrade,
    onCancelPendingOrder,
    onInputStopLoss,
    onInputTakeProfit,
    onInputPrice,
    onToggleFavourite,
    onShowChart,
    favourites,
    appMode,
    onSelectPosition,
  } = props
  let content: JSX.Element | undefined | false
  const sidebarOpened =
    appMode !== 'history' &&
    ((tradingPaneOpened && appMode === 'trade') ||
      (['assetPosition', 'positions'].includes(appMode) && positionExpanded) ||
      (appMode === 'orders' && orderExpanded))
  if (sidebarOpened) {
    switch (appMode) {
      case 'trade':
        content = tradingPaneOpened && <TradingPane />
        break
      case 'positions':
      case 'orders':
      case 'assetPosition':
        const position = ['positions', 'assetPosition'].includes(appMode)
          ? !!selectedPosition && positions.get(selectedPosition)
          : !!selectedOrder && pendingOrders.get(selectedOrder)
        const onClose = appMode === 'orders' ? onCancelPendingOrder : onCloseTrade
        content = position && (
          <PositionEdit
            key={position.order}
            asset={assets[position.symbol]}
            position={position}
            positionInput={positionsInputs[selectedPosition!] || {}}
            selectedPosition={selectedPosition}
            currency={currency}
            locale={locale}
            isPending={appMode === 'orders'}
            onSave={onModifyTrade}
            onClose={onClose.bind(null, position.order, position.uuid)}
            accountLoaded={accountLoaded}
            tradeOperationEnabled={tradeOperationEnabled}
            onInputStopLoss={onInputStopLoss}
            onInputTakeProfit={onInputTakeProfit}
            onInputPrice={onInputPrice}
            onShowChart={onShowChart}
            onToggleMenu={() => onSelectPosition(position.order, false)}
            favourites={favourites}
            onToggleFavourite={onToggleFavourite}
          />
        )
        break
    }
  }
  return (
    <div className={'sidebar' + (sidebarOpened ? ' show' : '')} data-cy="sideBar">
      {content}
    </div>
  )
}
